import { render, staticRenderFns } from "./CardItem3.vue?vue&type=template&id=b307c0d4&scoped=true&"
import script from "./CardItem3.vue?vue&type=script&lang=js&"
export * from "./CardItem3.vue?vue&type=script&lang=js&"
import style0 from "./CardItem3.vue?vue&type=style&index=0&id=b307c0d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b307c0d4",
  null
  
)

export default component.exports